/* eslint-disable import/no-import-module-exports */
import deepForceUpdate from 'react-deep-force-update';
import { render } from 'react-dom';
import { TrackJS } from 'trackjs'
import App from './App';

const container = document.getElementById('app');

const appData = JSON.parse(container.dataset.app);

let appInstance = null;

const renderApp = () => {
    try {
        if (process.env.NODE_ENV !== 'development' && !window.TrackJS && process.env.TRACKJS_TOKEN) {
            TrackJS.install({
                token: process.env.TRACKJS_TOKEN,
                application: process.env.REACT_APP_TRACKJS_APP
            })
            TrackJS.addMetadata("project", "vasco");
        }

        const appElement = <App appData={appData} />;
        appInstance = render(appElement, container);
    } catch (error) {
        if ('development' === process.env.NODE_ENV) {
            throw error;
        }
        console.error(error);
    }
};

renderApp();

// Enable Hot Module Replacement (HMR)
if (module.hot) {
    module.hot.accept('./App', () => {
        if (appInstance && appInstance.updater.isMounted(appInstance)) {
            // Force-update the whole tree, including components that refuse to update
            deepForceUpdate(appInstance);
        }

        renderApp();
    });
}
